import { render } from "./CreatOption.vue?vue&type=template&id=3f7da5e4"
import script from "./CreatOption.vue?vue&type=script&lang=js"
export * from "./CreatOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__